import { ArrowRight } from "lucide-react";

export function GoogleIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 48 48" aria-hidden="true">
      <path fill="#EA4335" d="M24 9.5c3.5 0 6.6 1.2 9 3.5l6.7-6.7C35.7 2.6 30.2 0 24 0 14.6 0 6.6 5.4 2.7 13.2l7.8 6C12.4 13.4 17.7 9.5 24 9.5z"/>
      <path fill="#4285F4" d="M46.5 24.5c0-1.6-.1-2.8-.4-4H24v8.1h12.7c-.3 2.2-1.7 5.4-4.9 7.6l7.5 5.8c4.5-4.1 7.2-10.2 7.2-17.5z"/>
      <path fill="#FBBC05" d="M10.5 28.6A14.5 14.5 0 0 1 9.7 24c0-1.6.3-3.1.7-4.6l-7.8-6A24 24 0 0 0 0 24c0 3.9.9 7.5 2.6 10.7l7.9-6.1z"/>
      <path fill="#34A853" d="M24 48c6.5 0 11.9-2.1 15.9-5.8l-7.5-5.8c-2 1.4-4.7 2.4-8.4 2.4-6.3 0-11.6-4-13.5-9.7l-7.9 6.1C6.6 42.6 14.6 48 24 48z"/>
    </svg>
  );
}

export function EmailAuthForm({ mode, form, setForm, error, busy, onSubmit }) {
  return (
    <form onSubmit={onSubmit} className="space-y-5" data-testid="login-form">
      {mode === "register" && (
        <label className="block"><div className="eyebrow mb-2">Your name</div>
          <input required value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} className="w-full border-b border-stone-300 py-2 bg-transparent outline-none focus:border-black" data-testid="login-name" /></label>
      )}
      <label className="block"><div className="eyebrow mb-2">Email</div>
        <input required type="email" value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} className="w-full border-b border-stone-300 py-2 bg-transparent outline-none focus:border-black" data-testid="login-email" /></label>
      <label className="block"><div className="eyebrow mb-2">Password</div>
        <input required type="password" minLength={6} value={form.password} onChange={e => setForm({ ...form, password: e.target.value })} className="w-full border-b border-stone-300 py-2 bg-transparent outline-none focus:border-black" data-testid="login-password" /></label>
      {error && <div className="text-sm text-red-700 border border-red-200 bg-red-50 px-3 py-2" data-testid="login-error">{error}</div>}
      <button type="submit" disabled={busy} data-testid="login-submit" className="w-full inline-flex items-center justify-center gap-2 bg-black text-white px-4 py-3 text-sm disabled:opacity-50">
        {busy ? "Please wait…" : mode === "login" ? "Sign in" : "Create account"} <ArrowRight size={14} />
      </button>
    </form>
  );
}
